export default __webpack_public_path__ + "static/media/gallery - story - hand (1)_05.fce7f2f0.jpg";